import ToastHighLighter from '@/lib/ToastHighLighter';

export const Select2Code = () => {
  const language = 'html';
  const codeString = `
  // Select2
  <html>
  <head>
    ...
    <script src="https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js"></script>
    ...
  </head>
  <body>
    ...
`;

  return (
    <>
      <ToastHighLighter
        name={'select2'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
